import { render } from "./App.vue?vue&type=template&id=6578cebc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6578cebc&lang=css"
const cssModules = script.__cssModules = {}
import style1 from "./App.vue?vue&type=style&index=1&id=6578cebc&module=true&lang=css"
cssModules["$style"] = style1
script.render = render

export default script